import {
  Box,
  Button,
  Card,
  Checkbox,
  Divider,
  IconButton,
  Modal,
  Paper,
  Typography,
} from "@mui/material";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import React, { useEffect, useState } from "react";
import clsx from "clsx";
import styled from "styled-components";
import { TourData } from "../../Data";
import { useDispatch, useSelector } from "react-redux";
import { ChangeTourValue } from "../../Redux/TourSlice";
import TourImage from "../../Assets/Videotourimage.jpg";
import Cookies from "universal-cookie";
import { RootState } from "../../Redux/UserSlice";
import { GetAcessToken, instance, Verify_Token } from "../../Controller/Common";
import { useNavigate } from "react-router-dom";

const CustomBox = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
`;
const ButtonBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  padding: 10px 10px;
`;
const IconBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
interface StateType {
  tour: {
    value: number;
  };
}

export default function TourModal() {
  const cookies = new Cookies();
  const [status, setStatus] = useState(false);
  const tour = cookies.get("tourModal");
  const userId =
    useSelector((state: RootState) => state.user.userID) ??
    cookies.get("userId");
  const tourStore = useSelector((state: RootState) => state.user.tour);
  const userName = useSelector((state: RootState) => state.user.userName);
  const [open, setOpen] = useState(tour || tourStore);

  const value = useSelector((state: StateType) => state.tour.value);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleRight = () => {
    if (value === 5) {
      dispatch(ChangeTourValue(-1));
      handleClose();
    } else {
      dispatch(ChangeTourValue(value + 1));
    }
  };
  const handleChange = async () => {
    setStatus(!status);
    postTour(status);
  };

  const handleLeft = () => {
    dispatch(ChangeTourValue(value - 1));
  };

  useEffect(() => {
    if (value === -1) {
      handleClose();
    }
  }, [value]);

  useEffect(() => {
    handleOpen();
  }, []);

  const IconGroup = () => {
    return (
      <IconBox>
        <Typography fontSize={"12px"} fontWeight={400} color="info.main">
          {value}&nbsp;/&nbsp;5
        </Typography>
        <IconButton disabled={value === 1}>
          <ArrowCircleLeftIcon
            color="info"
            onClick={() => handleLeft()}
            sx={{ cursor: "pointer", fontSize: "24px" }}
          />
        </IconButton>
        <IconButton disabled={value === 5}>
          <ArrowCircleRightIcon
            color="info"
            onClick={() => handleRight()}
            sx={{ cursor: "pointer", fontSize: "24px" }}
          />
        </IconButton>
      </IconBox>
    );
  };
  const postTour = async (toogle: any) => {
    try {
      const response = await instance.put(
        `6D/auth/update-tour?id=${userId}&status=${toogle}`
      );
      if (response.status === 200) {
        await GetAcessToken();
        await Verify_Token(dispatch, navigate);
        // dispatch(UpdateTour(toogle));
        setOpen(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ zIndex: 99 }}
      BackdropProps={{
        onClick: () => {
          dispatch(ChangeTourValue(0));
          // postTour(status);
          handleClose();
        },
      }}
    >
      <Paper
        elevation={0}
        className={clsx("tourModalPaper", {
          zero: value === 0,
          one: value === 1,
          two: value === 2,
          three: value === 3,
          four: value === 4,
          five: value === 5,
          // six: value === 5,
          minus: value === -1,
        })}
        sx={{ position: "relative" }}
      >
        {value === 0 && <img src={TourImage} alt="tourImage" width={280} />}
        {value !== 0 && (
          <Box sx={{ display: "flex", position: "absolute", left: "-4%" }}>
            <Box
              sx={{
                width: 0,
                height: 0,
                borderTop: "20px solid transparent",
                borderBottom: "20px solid transparent",
                borderRight: "10px solid #ffffff",
              }}
            >
              {""}
            </Box>
            <Box
              sx={{
                width: 0,
                height: 40,
                borderLeft: "5px solid #ffffff",
                bgcolor: "#ffffff",
              }}
            >
              {""}
            </Box>
          </Box>
        )}
        <Card elevation={0} className="tourModalCard">
          <CustomBox>
            {value === 0 && <StartTour userName={userName} />}
            {TourData.map(
              (item, index) =>
                value === item.value && (
                  <>
                    <Typography
                      fontSize={"14px"}
                      fontWeight={600}
                      variant="body1"
                      color="info.main"
                    >
                      {item.head}
                    </Typography>
                    <br />
                    <Typography
                      fontSize={"12px"}
                      fontWeight={400}
                      variant="body1"
                      color="info.main"
                    >
                      {item.content[0]}
                    </Typography>
                    <br />
                    <Typography
                      variant="body1"
                      color="info.main"
                      fontSize={"12px"}
                      fontWeight={400}
                    >
                      {item.content[1]}
                    </Typography>
                  </>
                )
            )}
          </CustomBox>
          <Divider className="tourModal" />
          <ButtonBox>
            <Button
              className="tourModalButtonSmall"
              onClick={() => {
                dispatch(ChangeTourValue(0));
                sessionStorage.setItem("temp", "true");
                // postTour(status);
                handleClose();
              }}
              sx={{ color: "info.main" }}
            >
              {"Skip Tour"}
            </Button>
            {value !== 0 ? (
              <IconGroup />
            ) : (
              <Button
                onClick={() => {
                  dispatch(ChangeTourValue(1));
                }}
                sx={{
                  color: "info.main",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                START TOUR
              </Button>
            )}
          </ButtonBox>
        </Card>
        <Typography className="tourCheckbox">
          Don't Show again &nbsp;{" "}
          <Checkbox size="small" checked={status} onChange={handleChange} />
        </Typography>
      </Paper>
    </Modal>
  );
}
type WelcomeProps = {
  firstName?: string;
  userName?: any;
};

const StartTour: React.FC<WelcomeProps> = ({ firstName, userName }) => {
  return (
    <>
      <>
        <Typography color="info.main" fontSize={"14px"} fontWeight={600}>
          Welcome{" "}
          <Typography
            component="span"
            sx={{ color: "info.main", fontSize: "14px", fontWeight: 600 }}
          >
            {userName === undefined || null ? "User" : userName}
          </Typography>
          ,{" "}
        </Typography>
        <br />
        <Typography fontSize={"12px"} fontWeight={400} color="info.main">
          Take a quick tour to explore the key features and get started on your
          learning journey. Already familiar? Feel free to skip and dive right
          in!
        </Typography>
      </>
    </>
  );
};
